import { _ as _define_property } from "@swc/helpers/_/_define_property";
export var AccountingCustomerStatus = /*#__PURE__*/ function(AccountingCustomerStatus) {
    AccountingCustomerStatus["Active"] = "Active";
    AccountingCustomerStatus["Archived"] = "Archived";
    AccountingCustomerStatus["Unknown"] = "Unknown";
    return AccountingCustomerStatus;
}({});
export class AccountingCustomerModel {
    static fromDTO(dto) {
        return new AccountingCustomerModel(dto);
    }
    id() {
        return this.data.id;
    }
    customerName() {
        return this.data.customerName;
    }
    contactName() {
        return this.data.contactName;
    }
    displayName() {
        return this.data.displayName;
    }
    formattedDisplay() {
        return "".concat(this.data.displayName, " (").concat(this.data.customerName, ")");
    }
    emailAddress() {
        return this.data.emailAddress;
    }
    constructor(data){
        _define_property(this, "data", void 0);
        this.data = data;
    }
}
